import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  box: {
    maxWidth: 720,
    margin: '0 auto',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },
  loaderBox: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    height: 'calc(100% - 86px)',
    [theme.breakpoints.only('xs')]: {
      flexDirection: 'column',
    },
  },
  infoBox: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.only('xs')]: {
      order: 2,
    },
  },
  post: {
    width: 720,
    [theme.breakpoints.only('xs')]: {
      width: 320,
      flexGrow: 1,
    },
  },
  contentBox: {
    [theme.breakpoints.only('xs')]: {
      marginTop: -theme.spacing(5),
      marginBottom: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
    },
  },
  icon: {
    marginTop: 74,
    [theme.breakpoints.only('xs')]: {
      marginTop: -80,
      width: 360,
    },
    [theme.breakpoints.down(365)]: {
      width: 320
    },
  },
  text404: {
    fontSize: 72,
    fontWeight: 800,
    [theme.breakpoints.only('xs')]: {
      textAlign: 'center',
    },
  },
  txtNotExists: {
    marginBottom: theme.spacing(4),
    fontSize: 24,
    fontWeight: 500,
  },
  btnHomepage: {
    fontSize: 12,
  },
}));

export { useStyles };
